import { init as clientInit } from '~/api/client';

export default ({ $axios }) => {
  clientInit($axios);
};
